import { render, staticRenderFns } from "./MenuV2.vue?vue&type=template&id=f6e040bc&scoped=true&"
import script from "./MenuV2.vue?vue&type=script&lang=js&"
export * from "./MenuV2.vue?vue&type=script&lang=js&"
import style0 from "./MenuV2.vue?vue&type=style&index=0&id=f6e040bc&lang=scss&scoped=true&"
import style1 from "./MenuV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e040bc",
  null
  
)

export default component.exports